<template>
  <div class="container p-4">
    <card>
      <div class="row">
        <div class="col-md-8"></div>

        <div class="col-md-9">
          <h4 slot="header" class="card-title">{{ window_title }}</h4>
        </div>
        <!-- <div class="cold-md-3">
          <button
            type="button"
            class="btn btn-sm bg-gradient-fvf float-right"
            @click.prevent="returnUrl"
          >
            Volver
          </button>
        </div> -->
      </div>

      <form role="form">
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-12">
              <base-input
                type="text"
                label="Nombres"
                placeholder="Indica tus nombres"
                v-model="form_update.first_name"
              >
              </base-input>
            </div>
            <div class="col-md-12">
              <base-input
                type="text"
                label="Apellidos"
                placeholder="Indica tus apellidos"
                v-model="form_update.last_name"
              >
              </base-input>
            </div>
            <div class="col-md-12">
              <base-input
                type="text"
                label="Cédula de identidad / Pasaporte"
                placeholder="Indica tu cédula o pasaporte"
                v-model="form_update.dni"
              >
              </base-input>
            </div>
            <div class="col-md-12">
              <base-input
                type="number"
                label="Teléfono"
                placeholder="Indica tu teléfono"
                v-model="form_update.phone"
              >
              </base-input>
            </div>
            <div class="col-md-12">
              <label>¿Qué tipo de usuario eres?</label>
              <multiselect
                v-model="form_update.id_type_user"
                label="name"
                :options="TypeUserTmp"
                selectLabel="Click/enter para elegir"
                selectedLabel="Seleccionado"
                deselectLabel="Click/Enter para remover"
                select-label="Seleccionar"
                placeholder="Seleccione"
                style="border-radius: 30px !important; text-transform: none"
              >
              </multiselect>
            </div>
            <div class="col-md-6 mt-4">
              <label>Imagen de perfil</label>
              <br />
              <div style="position: relative">
                <file-pond
                  ref="filePond"
                  accepted-file-types="image/jpeg, image/png"
                  name="image"
                  v-model="form_update.url_image"
                  label-idle="Subir imagen"
                  @updatefiles="handleFileUpdate"
                  @removefile="handleFileUpdate"
                ></file-pond>
                <img
                  id="backgroundImage"
                  src="../../../public/img/load_img.jpg"
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    pointer-events: none;
                    opacity: 0.5;
                    height: 148px;
                  "
                />
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="col-md-12">
              <base-input
                type="email"
                label="Correo"
                placeholder="Indica tu correo"
                v-model="form_update.email"
              >
              </base-input>
            </div>

            <div class="col-md-12">
              <label>País</label>
              <multiselect
                v-model="form_update.country"
                label="name"
                :options="sortedCountryTmp"
                selectLabel="Click/enter para elegir"
                selectedLabel="Seleccionado"
                deselectLabel="Click/Enter para remover"
                select-label="Seleccionar"
                placeholder="Seleccione"
                @input="loadState()"
                style="
                  border-radius: 30px !important;
                  text-transform: capitalize;
                "
              >
              </multiselect>
            </div>

            <div class="col-md-12">
              <label>Estado</label>
              <multiselect
                v-model="form_update.state"
                label="name"
                :options="StateTmp"
                selectLabel="Click/enter para elegir"
                selectedLabel="Seleccionado"
                deselectLabel="Click/Enter para remover"
                select-label="Seleccionar"
                placeholder="Seleccione"
                style="
                  border-radius: 30px !important;
                  text-transform: capitalize;
                "
                :disabled="!form_update.country"
              >
              </multiselect>
              <p
                v-if="!form_update.country"
                style="
                  color: rgb(184, 49, 49);
                  text-transform: none !important;
                  font-size: 11px;
                "
              >
                Debe seleccionar un Pais para seleccionar un Estado
              </p>
            </div>

            <div class="col-md-12">
              <label>Actualizar contraseña</label>
              <input
                type="checkbox"
                class="ms-2"
                v-model="showPasswordFields"
              />
            </div>

            <div v-if="showPasswordFields" class="col-md-12">
              <base-input
                type="password"
                label="Contraseña"
                placeholder="Indica tu contraseña"
                v-model="form_update.password"
              >
              </base-input>
            </div>
            <div v-if="showPasswordFields" class="col-md-12">
              <base-input
                v-if="form_update.password"
                type="password"
                label="Repite la contraseña"
                placeholder="Confirma tu contraseña"
                v-model="form_update.password2"
              >
              </base-input>
              <base-input
                v-else
                type="password"
                label="Repite la contraseña"
                placeholder="Confirma tu contraseña"
                v-model="checkEmptyPassword"
                disabled
              >
              </base-input>
            </div>
            <div
                            v-if="
                              form_update.id_type_user.id == 1 ||
                              form_update.id_type_user.id == 3
                            "
                            class="col-md-12"
                          >
                            <base-input
                              type="text"
                              label="ID de entrenador"
                              placeholder="Indica tu ID de entrenador"
                              v-model="form_update.id_rne"
                            >
                            </base-input>
                          </div>
            <div class="col-md-12 mt-4">
              <div class="text-center">
                <button
                  type="button"
                  class="btn bg-gradient-fvf"
                  @click="updateElement"
                >
                  <span>Actualizar</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import LTable from "src/components/Table.vue";
import moment from "moment";
import LoadImage from "../../../public/img/load_img.jpg";
import ObservationChat from "src/components/ObservationChat.vue";
import Cookies from "js-cookie";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    DatePicker,
    LTable,
    ObservationChat,
  },
  data() {
    return {
      window_title: "Mi perfil",
      button_label: "Actualizar información",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      countries: [],
      loaded: false,
      showPasswordFields: false,

      id_user_logged: Cookies.get("id"),
      form_update: {
        id: 0,
        url_image: "",
        first_name: "",
        last_name: "",
        dni: "",
        phone: "",
        email: "",
        id_rne: "",
        id_type_user: {
          id: 0,
          name: "",
        },
        country: {
          id: "",
          name: "",
        },
        state: {
          id: "",
          name: "",
        },
      },

      TypeUserTmp: [
        { id: 1, name: "Entrenador" },
        { id: 2, name: "Jugador retirado" },
        { id: 3, name: "Entrenador y Jugador retirado" },
        { id: 0, name: "Ninguno de los anteriores" },
      ],

      CountryTmp: [],
      StateTmp: [],
    };
  },
  mounted() {
    this.getElement(this.id_user_logged);
    this.loadCountry();
    this.loadState();
    DatePicker.locale("es", es);
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    sortedStateTmp() {
      return this.StateTmp.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedCountryTmp() {
      return this.CountryTmp.sort((a, b) => a.name.localeCompare(b.name));
    },

    checkEmptyPassword() {
      console.log('hola');
      if (this.form_update.password == "") {
        return (this.form_update.password2 = "");
      }
    },
  },
  methods: {
    ...mapActions(["getData", "updateData", "changeStatusData", "createData",'updateDataAutenticated']),
    showObs() {
      $("#modalObs").modal("toggle");
      this.$refs.ObservationChat.loadObservations();
    },

    changeDate() {
      console.log(this.form_update.date_registration_rif);
    },

    prefixChange() {
      console.log(this.form_update.prefix);
      this.prefixTemp = [
        {
          id: 0,
          name: "V-",
        },
        {
          id: 1,
          name: "J-",
        },
        {
          id: 2,
          name: "G-",
        },
        {
          id: 3,
          name: "E-",
        },
      ];
    },

    getElement(id) {
      this.loaded = false;
      let data_params = {
        url: "user/user/myprofile/",
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          this.form_update = response.data;

          this.form_update.id_type_user = this.TypeUserTmp.find(
            (x) => x.id === this.form_update.id_type_user
          );
          this.loadCountry();
          this.loadState();

          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },
    returnUrl() {
      this.$router.go(-1);
    },

    changeStatus(data) {
      let active = data.active === 1 ? 2 : 1;
      let title = data.active === 1 ? "Eliminar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de eliminar este usuario?"
          : "¿Estás seguro de activar este usuario?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#430098ff",
        cancelButtonColor: "#c4c5c8ff",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user_club/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserClubs();
                data.active = active;
                Swal.fire({
                  title: "Usuario eliminado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  confirmButtonColor: "#430098ff",
                  timer: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    handleFileUpdate(files) {
      if (
        files.length > 0 &&
        files[0].file !== undefined &&
        files[0].file !== null &&
        files[0].file !== ""
      ) {
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
          const backgroundImage = document.getElementById("backgroundImage");
          backgroundImage.src = "";
        };

        reader.readAsDataURL(file.file);
      } else {
        console.log("No hay archivo");
        const backgroundImage = document.getElementById("backgroundImage");
        backgroundImage.src = LoadImage;
      }
    },

    updateElement() {
      if (this.form_update.password !== this.form_update.password2) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.country) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar un país",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.state) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar un estado",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.id_type_user) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe seleccionar un tipo de usuario",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.first_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un nombre",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.last_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un apellido",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.dni) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un número de cédula o pasaporte",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.phone) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un número de teléfono",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.email) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un correo electrónico",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      }else if (this.form_update.id_type_user.id == 1 && this.form_update.rne == "" || this.form_update.id_type_user.id == 3 && this.form_update.rne == "" ) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un ID de entrenador",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de actualizar su información?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, actualizar",
        }).then((result) => {
          let data_form;

          if (result.value) {
            data_form = new FormData();
            data_form.append("first_name", this.form_update.first_name);
            data_form.append("last_name", this.form_update.last_name);
            data_form.append("email", this.form_update.email);
            data_form.append("phone", this.form_update.phone);
            data_form.append("id_type_user", this.form_update.id_type_user.id);
            data_form.append("id_country", this.form_update.country.id);
            data_form.append("id_state", this.form_update.state.id);
            data_form.append("dni", this.form_update.dni);
            if(this.form_update.id_type_user.id == 1 || this.form_update.id_type_user.id == 3){
              data_form.append("id_rne", this.form_update.id_rne);
            }else{
              data_form.append("id_rne", "");
            }
            if (
              this.form_update.password !== "" &&
              this.form_update.password !== null &&
              this.form_update.password !== undefined
            ) {
              data_form.append("password", this.form_update.password);
            }
            console.log(this.form_update);
            console.log("hola", this.$refs.filePond.getFiles());
            const filePondInstance = this.$refs.filePond.getFiles();
            if (
              filePondInstance &&
              filePondInstance.length > 0 &&
              filePondInstance[0].file
            ) {
              data_form.append("url_image", filePondInstance[0].file);
            }
          }

          this.deleting = true;
          let form = {
            url: "user/user/update",
            // id: this.form_update.id,
            data: data_form,
          };
          this.updateDataAutenticated(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Datos actualizados correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });

                const id_type_user = this.form_update.id_type_user.id;
                const expires_in = moment().format("YYYY-MM-DD HH:mm");
                const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
                const expires_at_date = new Date(expires_at);
                Cookies.remove("id_type_user");
                Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });

                location.reload(true);
              }
              if (response.code === 403) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe otro usuario con este teléfono",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 409) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe un usuario con estos datos",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 410) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este RNE",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              alert("Ocurrió un error, intente más tarde");
            });
        });
      }
    },

    loadState() {
      let form = {
        url: "master/state/all",
        params: {
          id_country: this.form_update.country
            ? this.form_update.country.id
            : null,
          order_key: "asc",
          order_by: "name",
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.StateTmp = response.data;

            // this.loadCity();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_key: "asc",
          order_by: "name",
          active: 1,
        },
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CountryTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #b49b57;
  border-color: #b49b57;
}
.filepond--drop-label {
  height: 148px !important;
}
.filepond--drop-label.filepond--drop-label label {
  margin-top: 100px;
  text-align: center !important;
  color: black !important;
  font-size: small;
}
</style>
<style scoped>
/* Define la altura máxima y permite el desplazamiento */
.scrollable {
  max-height: 400px;
  overflow-y: auto;
}
.user-header {
  font-weight: bold;
  font-size: 15.6px;
}
.user-row {
  font-size: 15.6px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
